export function createSloManagementClient(transport) {
    return {
        /**
         * List every tenant's service objectives, with the error budget as a ratio
         *
         * Requires scope: slo:platform:read
         */
        listPlatformSlos(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/slos",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/slos
         *
         * Requires scope: slo:write
         */
        defineSlo(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/slos`,
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/slos/{sloId}
         *
         * Requires scope: slo:read
         */
        getSlo(tenantId, sloId, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/slos/${encodeURIComponent(sloId)}`,
                options,
            });
        },
        /**
         * PUT /internal/v1/tenants/{tenantId}/slos/{sloId}
         *
         * Requires scope: slo:write
         */
        reviseSlo(tenantId, sloId, options) {
            return transport.request({
                method: "PUT",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/slos/${encodeURIComponent(sloId)}`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/slos/{sloId}/evaluations
         *
         * Requires scope: slo:evaluate
         */
        recordSloEvaluation(tenantId, sloId, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/slos/${encodeURIComponent(sloId)}/evaluations`,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=slo-management.js.map